export default {
    getDocument: state => {
      return state.currentDocument;
    },
    getParts:state => {
      return state.parts;
    },
    getAllByLaws: state => {
      return state.documents;
    },
    dataLoaded: state => {
      return state.dataAvailable;
    },
    getSharePath: state => {
      return state.sharePath;
    },
    getDefinitions: state => {
      return state.definitions;
    },
   getDefinitionStatus: state =>{
     return state.definitionAvailable;
   },
    getShareRequestStatus: state => {
      return state.requestSuccess;
    },
    getServiceStatus: state =>{
      return state.serviceUnavailable;
    }
  };
   